module.exports = __webpack_public_path__ + "media/images/line-5-1@1x-70115933d879825709652e3419009889.png";